<template>
  <div>
    <header class="header-global  fixed-top">
      <base-nav class="navbar-main " fixed style="background-color: black; opacity: 1" transparent type=""
        effect="light" expand>
        <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
          <img src="logo2.png" alt="logo" />

        </router-link>

        <div class="row" slot="content-header" slot-scope="{closeMenu}">
          <div class="col-6 collapse-brand">
            <a href="https://vivaticket.autsteeltech.com/">
              <img src="logo2.png" alt="logo" />
            </a>
          </div>
          <div class="col-6 collapse-close">
            <close-button @click="closeMenu"></close-button>
          </div>

        </div>


        <a v-if="usuario == null" slot="brand" @click="modalLogin = true" rel="noopener"
          class="navbar-brand ml-lg-5  btn btn-neutral btn-icon">
          <span class="btn-inner--icon">
            <!-- <i class="fa fa-cloud-download mr-2"></i> -->
          </span>
          <span class="nav-link-inner--text">Login</span>
        </a>




        <base-dropdown slot="brand" tag="li" v-if="usuario != null" style="color:white;" class="nav-item">
          <a slot="title" class="nav-link" data-toggle="dropdown" role="button">
            <span class="nav-link-inner--text">Olá, {{ usuario.usuario.nome_sobrenome }}
            </span>
            <i class="fa fa-user"></i>
          </a>
          <router-link v-if="usuario != null" to="/compras" class="dropdown-item">Minhas Compras</router-link>
          <router-link v-if="usuario != null" v-show="usuario.usuario.perfil_id == 3" to="/produtor"
            class="dropdown-item">Meus Eventos</router-link>
          <router-link v-if="usuario != null" to="/profile" class="dropdown-item">Meu Perfil
          </router-link>
          <!-- <a v-if="usuario!= null" @click.prevent="sair()" class="dropdown-item">Sair    </a>
                    <a  v-if="usuario== null" @click.prevent="logar()" class="dropdown-item">Sair    </a> -->
          <a v-if="usuario != null" @click.prevent="sair()" class="dropdown-item">Sair
          </a>
        </base-dropdown>


        <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
          <li class="nav-item">
            <a @click="route('home')" slot="title" href="#" class="nav-link nav-link-icon">
              <i class="ni ni-spaceship d-lg-none"></i>
              <span class="nav-link-inner--text">Inicio</span>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a
              slot="title"
              href="https://sis.boraticketstore.com.br/usuario/index.asp"
              class="nav-link nav-link-icon"
            >
              <i class="ni ni-single-02 d-lg-none"></i>
              <span class="nav-link-inner--text">Usuários</span>
            </a>
          </li> -->
          <li class="nav-item">

            <router-link style="color: white;" v-if="usuario != null" to="/compras">Minhas Compras</router-link>
          </li>
          <li class="nav-item">
            <a slot="title" href="https://painel.vivaticket.autsteeltech.com/" class="nav-link nav-link-icon">
              <i class="ni ni-collection d-lg-none"></i>
              <span class="nav-link-inner--text">ADM</span>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a slot="title" href="https://sis.boraticketstore.com.br//adm_novo/index.asp?status="
              class="nav-link nav-link-icon">
              <i class="ni ni-collection d-lg-none"></i>
              <span class="nav-link-inner--text">Produção </span>
            </a>
          </li> -->
        </ul>
        <ul class="navbar-nav align-items-lg-center ml-lg-auto">
          <li class="nav-item">
            <a class="nav-link nav-link-icon" href="https://web.facebook.com/profile.php?id=100065304107548"
              target="_blank" rel="noopener" data-toggle="tooltip" title="Like us on Facebook">
              <i class="fa fa-facebook-square"></i>
              <span class="nav-link-inner--text d-lg-none">Facebook</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-link-icon" href="https://www.instagram.com/boraticketstore/" target="_blank"
              rel="noopener" data-toggle="tooltip" title="Follow us on Instagram">
              <i class="fa fa-instagram"></i>
              <span class="nav-link-inner--text d-lg-none">Instagram</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-link-icon" href="https://wa.me/+5567996962031" target="_blank" rel="noopener"
              data-toggle="tooltip" title="Follow us on Instagram">
              <i class="fa fa-whatsapp"></i>
              <span class="nav-link-inner--text d-lg-none">WhatsApp</span>
            </a>
          </li>
          <li class="nav-item  ml-lg-4">

          </li>

        </ul>

      </base-nav>
    </header>
    <modal :show.sync="modalLogin" body-classes="p-3" modal-classes="modal-dialog-centered modal-lg"
      style="font-weight: 900">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Login do cliente
      </h6>

      <div class="form">
        <div class="row form-group">
          <div class="col-md-6">
            <label>Email:*</label>
            <input required="" placeholder="Seu E-mail" v-model="form_login.email" class="form-control" :class="form_login.email == ''
                ? validate_form_login.email
                : 'border-2 border-success'
              " />
          </div>
          <div v-if="esqsenha" class="col-md-12">
            <b-button class="mr-2 mt-3" @click="passemail()" variant="success">Enviar Email de Recuperação</b-button>
            <b-button class="mr-2 mt-3" @click="esqsenha = false" variant="success">Cancelar</b-button>
          </div>

          <div v-if="!esqsenha" class="col-md-6">
            <label>Senha:*</label>
            <input required="" type="password" placeholder="Sua senha" v-model="form_login.password" :class="form_login.password == ''
                ? validate_form_login.password
                : 'border-2 border-success'
              " class="form-control" />
            <a style="color: blue; text-decoration-line: underline" @click="esqsenha = true">
              Esqueci a Senha!</a>
          </div>
        </div>
      </div>

      <b-button v-if="!esqsenha" class="pull-right mr-5 mt-3" @click="validate2()" variant="success">Logar</b-button>
      <b-button @click="modalCadastro = true" v-if="usu_logado == true" class=" mr-3 mt-3"
        variant="success">Cadastre-se</b-button>
      <br>

      <span style="font-size:14px;"> <i class="text-uppercase">*Atenção Usuário</i>, caso esteja com difilcudade de
        acesso tente se cadastrar novamente. Estamos com uma nova versão do sistema</span>

      <template slot="footer">

        <b-button size="sm" type="link" class="ml-auto" @click="modalCadastro = false">Cancelar
        </b-button>
      </template>
    </modal>
    <modal :show.sync="modalCadastro" body-classes="p-3" modal-classes="modal-dialog-centered modal-lg"
      style="font-weight: 900">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        CADASTRO DE CLIENTES
      </h6>

      <div class="form">
        <div class="row form-group">
          <div class="col-md-12">
            <label>Email:*</label>
            <input required="" placeholder="Seu E-mail" v-model="form.email" class="form-control" :class="form.email == confirme_email
                ? 'border-2 border-success'
                : 'border-2 border-danger'
              " />
          </div>
          <div class="col-md-12">
            <label>Confirme seu email:*</label>
            <input required="" placeholder="Seu E-mail" v-model="confirme_email" class="form-control" :class="form.email == confirme_email
                ? 'border-2 border-success'
                : 'border-2 border-danger'
              " />
          </div>
          <div class="col-md-6">
            <label>Senha:*</label>
            <input required="" type="text" placeholder="Sua senha" v-model="form.password" :class="confirme_password == form.password
                ? 'border-2 border-success'
                : 'border-2 border-danger'
              " class="form-control" />
          </div>
          <div class="col-md-6">
            <label>Confirme sua Senha:*</label>
            <input required="" type="password" placeholder="Sua senha" v-model="confirme_password" :class="confirme_password == form.password
                ? 'border-2 border-success'
                : 'border-2 border-danger'
              " class="form-control" />
          </div>
          <div class="col-md-6">
            <label>Nome:*</label>
            <input required="" placeholder="O seu Nome" v-model="form.nome" :class="form.nome == '' ? validate_form.nome : 'border-2 border-success'
              " class="form-control" />
          </div>
          <div class="col-md-6">
            <label>Sobrenome:*</label>
            <input required="" placeholder="O seu Sobrenome" v-model="form.sobrenome" :class="form.sobrenome == ''
                ? validate_form.sobrenome
                : 'border-2 border-success'
              " class="form-control" />
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-6">
            <label for="cpf">CPF*</label>
            <input required="" type="text" class="form-control" id="cpf" v-mask="variableWithMask2" v-model="cpf_cnpj2"
              :class="form.cpf == '' ? validate_form.cpf : 'border-2 border-success'
                " placeholder="O cpf ou Cnpj" />
          </div>
          <div class="col-md-6">
            <label for="telefone1">WhatsApp :*</label>
            <span v-if="radio == 1" style="font-size: 9px">Obs: O 9 há mais ja colocado automaticamento
            </span>
            <input required="" type="text" class="form-control" id="telefone1" v-mask="variableWithMaskTel" :class="form.telefone1 == ''
                ? validate_form.telefone1
                : 'border-2 border-success'
              " v-model="tel1" placeholder="O telefone/celular..." />
            <b-form-radio-group @input="ra" v-model="radio" label="" v-slot="{ ariaDescribedby }">
              <b-form-radio :aria-describedby="ariaDescribedby" name="some-radios" :value="1">Brasil +55</b-form-radio>
              <b-form-radio :aria-describedby="ariaDescribedby" name="some-radios" :value="2">Paraguai
                +595</b-form-radio>
            </b-form-radio-group>
          </div>
          <div class="col-md-3 mt-2">
            <label> CEP:</label>
            <input placeholder="Digite seu cep" v-model="form.cep" :class="form.cep == '' ? validate_form.cep : 'border-2 border-success'
              " v-mask="'########'" class="form-control" @input="cepinput" />
            <label> obs: Somente Numeros</label>
          </div>
          <div class="col-md-3 mt-2">
            <label> UF:</label>
            <input placeholder="Digite seu uf" v-model="form.uf" :class="form.uf == '' ? validate_form.uf : 'border-2 border-success'
              " class="form-control" />
          </div>
          <div class="col-md-6 mt-2">
            <label> Cidade:</label>
            <input placeholder="Digite sua cidade" v-model="form.cidade" :class="form.cidade == ''
                ? validate_form.cidade
                : 'border-2 border-success'
              " class="form-control" />
          </div>

          <div class="col-md-6 mt-2">
            <label> Bairro:</label>
            <input placeholder="Digite seu bairro" v-model="form.bairro" :class="form.bairro == ''
                ? validate_form.bairro
                : 'border-2 border-success'
              " class="form-control" />
          </div>
          <div class="col-md-6 mt-2">
            <label> Rua:</label>
            <input placeholder="Digite seu rua" v-model="form.rua" :class="form.rua == '' ? validate_form.rua : 'border-2 border-success'
              " class="form-control" />
          </div>
          <div class="col-md-3 mt-2">
            <label> Numero:</label>
            <input placeholder="Digite numero do endereço" v-model="form.numero" :class="form.numero == ''
                ? validate_form.numero
                : 'border-2 border-success'
              " class="form-control" />
          </div>
        </div>
      </div>

      <b-button :disabled="confirme_password != form.password" class="pull-right mr-5 mt-3" @click="validate()"
        variant="success">Salvar</b-button>

      <template slot="footer">
        <b-button size="sm" type="link" class="ml-auto" @click="modalCadastro = false">Cancelar
        </b-button>
      </template>
    </modal>
  </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";

import Modal from "@/components/Modal.vue";

import CloseButton from "@/components/CloseButton";
import usuarioService from "@/core/services/usuario.service";
import { fireAlert } from "@/core/mixins/alertMessageMixin";

export default {
  mixins: [fireAlert],
  data() {
    return {
      modalCadastro: false,
      esqsenha: false,
      modalLogin: false,
      modalin: false,
      form_login: {
        email: "",
        password: "",
      },
      validate_form_login: {
        email: null,
        password: null,
      },
      qrcode: null,
      size: 100,
      usu_logado: usuarioService.getUsuario() ?? true,
      usuario: usuarioService.getUsuario() ?? null,
      form: {
        email: "",
        nome: "",
        sobrenome: "",
        cpf: "",
        password: "",
        telefone1: "",
        cep: "",
        rua: "",
        numero: "",
        bairro: "",
        uf: "",
        cidade: "",
      },
      variableWithMask2: "",
      validate_form: {
        email: null,
        nome: null,
        sobrenome: null,
        cpf: null,
        password: null,
        telefone1: null,
        cep: null,
        rua: null,
        numero: null,
        bairro: null,
        cidade: null,
        uf: null,
      },
      variableWithMaskTel: "",
      tel1: null,
      cpf_cnpj2: null,
      confirme_password: null,
      confirme_email: null,
      radio: 1,
    };
  },
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    Modal,
  },
  watch: {
    cpf_cnpj2: function () {
      this.variableWithMask2 =
        this.cpf_cnpj2.replace(/[^0-9]/g, "").length <= 11
          ? "###.###.###-##"
          : "##.###.###/####-##";
      this.form.cpf = this.cpf_cnpj2.replace(/[^0-9]/g, "");
    },
    tel1: function () {
      this.variableWithMaskTel =
        this.radio == 1 ? "(##)9####-####" : "+595-###-######";

      if (this.radio == 1) {
        this.form.telefone1 = this.tel1.replace(/[^0-9]/g, "");
        this.form.ddd = this.form.telefone1.substring(2, 4);
      } else {
        this.form.telefone1 = this.tel1.replace(/[^0-9]/g, "");
      }
    },
  },
  computed: {
    mensagem_alert() {
      return this.$store.state.cliente.mensagem_alert;
    },
    cep() {
      return this.$store.state.evento.cep;
    },
  },
  methods: {
    async passemail() {
      await this.$store.dispatch("cliente/recuperar_senha", this.form_login);
      this.fireAlert({
        ...this.mensagem_alert,
      });

      this.esqsenha = false;
    },
    route(route) {
      if (this.$route.path !== "/") {
        this.$router.push({ name: route });

      }
    },
    getAt() {
      setTimeout(() => {
        window.location.reload(true);
      });
    },
    sair() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "home" });

      this.usuario = null;
    },
    async validate() {
      let p = true;
      for (var k in this.validate_form) {
        //  console.log("Chave: " + k + ", Valor: " + this.form[k]);
        if (this.form[k] == "") {
          this.validate_form[k] = "border-2 border-danger";
        } else {
          this.validate_form[k] = "border-2 border-success";
        }
      }
      for (var j in this.validate_form) {
        if (this.validate_form[j] == "border-2 border-danger") {
          p = false;
          console.log(j);
        }
      }

      if (p == true) {
        await this.$store.dispatch("cliente/create_cliente", this.form);
        this.fireAlert({
          ...this.mensagem_alert,
        });
        this.modalCadastro = false;
      }
    },
    async validate2() {
      let p = true;
      for (var k in this.validate_form_login) {
        //  console.log("Chave: " + k + ", Valor: " + this.form[k]);
        if (this.form_login[k] == "") {
          this.validate_form_login[k] = "border-2 border-danger";
        } else {
          this.validate_form_login[k] = "border-2 border-success";
        }
      }
      for (var j in this.validate_form_login) {
        if (this.validate_form_login[j] == "border-2 border-danger") {
          p = false;
          console.log(j);
        }
      }

      if (p == true) {
        await this.$store
          .dispatch("login", this.form_login)
          .then(() => {
            this.$fire({
              title: "Aviso",
              text: "Login Concluido Continue sua compra",
              type: "success",
              timer: 2000,
            });
            this.usuario = usuarioService.getUsuario() ?? null;
            this.modalLogin = false;
          })
          .catch(() =>
            this.$fire({
              title: "Aviso",
              text: "Verifique se seus dados estao corretos",
              type: "Warning",
              timer: 2000,
            })
          );
      }
    },
    async cepinput() {
      this.form.cep = this.form.cep.replace(/[^0-9]/g, "")
      if (this.form.cep.length == 8) {
        await this.$store.dispatch("evento/cep", this.form.cep);
        this.form.bairro = this.cep.bairro;
        // this.form.pais = "br";
        this.form.cidade = this.cep.localidade;
        this.form.uf = this.cep.uf;
        this.form.rua = this.cep.logradouro;
      }
    },
    ra() {
      this.variableWithMaskTel =
        this.radio == 1 ? "+(##)9####-####" : "+595-###-######";
    },
  },
};
</script>
<style></style>
